var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{'sbar-grip': true, 'mod-sidebar-visible': _vm.$store.state.sidebarVisible},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.collapseOrUncollapse($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }